<template>
	<div>
		<el-card v-show="isEdit">
			<div style="display: flex;"><el-button style="margin-left: auto;" @click="isEdit = false">返回列表</el-button></div>
		</el-card>
		<el-card style="margin:18px 0px">
			<div v-show="!isEdit">
				<el-table ref="multipleTable" :data="agreementList" tooltip-effect="dark" style="width: 100%">
					<el-table-column prop="id" label="ID" width="50"></el-table-column>
					<el-table-column prop="title" label="标题"></el-table-column>
					<el-table-column prop="create_time" :formatter="$f.timeFormat" label="创建时间" show-overflow-tooltip></el-table-column>
					<el-table-column align="center" label="管理" width="200">
						<template slot-scope="scope">
							<el-button @click="articleEdit(scope.row)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 编辑 -->
			<div v-show="isEdit">
				<el-form ref="form" :model="form" label-width="80px">
					<el-form-item label="标题" prop="title"><el-input v-model="form.title"></el-input></el-form-item>
					<el-form-item><editor-bar ref="editor" @change="change" v-model="form.content"></editor-bar></el-form-item>
					<el-form-item><el-button type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="onSubmit">提交</el-button></el-form-item>
				</el-form>
			</div>
		</el-card>
	</div>
</template>

<script>
import EditorBar from '../../components/wangeditor/index.vue';
export default {
	components: {
		EditorBar
	},
	data() {
		return {
			btnLoading: false,
			btnDisabled: false,
			agreementList: [],
			form: {
				title: '',
				content: ''
			},
			isEdit: false
		};
	},
	created() {
		this.getAgreement();
	},
	methods: {
		articleEdit(e) {
			this.isEdit = true;

			this.form.id = e.id;
			this.form.title = e.title;
			this.form.content = e.content;
			this.$refs.editor.setTxt(e.content);
		},
		getAgreement() {
			this.$H.get('agreement/list').then(res => {
				this.agreementList = res.result;
			});
		},
		onSubmit() {
			this.btnLoading = true;
			this.btnDisabled = true;

			if (!this.form.title) {
				this.$message.error('标题不能为空');
				this.btnLoading = false;
				this.btnDisabled = false;
				return;
			}

			if (!this.form.content) {
				this.$message.error('内容不能为空');
				this.btnLoading = false;
				this.btnDisabled = false;
				return;
			}
			this.$H.post('agreement/agreementSave', this.form).then(res => {
				if (res.code === 200) {
					this.$refs.form.resetFields();
					this.form.content = '';
					this.$refs.editor.clear();

					this.$message.success(res.msg);

					this.isEdit = false;
					this.getAgreement();
				}

				this.btnLoading = false;
				this.btnDisabled = false;
			});
		},
		change(html) {
			this.form.content = html;
		}
	}
};
</script>

<style>
.el-dropdown-link {
	cursor: pointer;
	color: #409eff;
}

.el-icon-arrow-down {
	font-size: 12px;
}

/* 上传 */
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 150px;
	height: 150px;
	line-height: 150px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
</style>
